module.exports = __webpack_public_path__ + "static/media/icon_cq.9ec7237a.svg";


//////////////////
// WEBPACK FOOTER
// ./src/asset/image/pageTic/icon_cq.svg
// module id = 584
// module chunks = 0